import { Component, OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef, ViewChild, TemplateRef} from '@angular/core';
import { ReactiveFormsModule, FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import {DemoService} from '../../../demo.service';
import {Routes, RouterModule, Router} from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Location} from '@angular/common';
// Notifications
// import { HotToastService } from '@ngneat/hot-toast';
import { DatePipe } from '@angular/common';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { Observable } from 'rxjs'; // this created errors ats use below
// import {Observable} from 'rxjs/Rx';
// import {Observable} from 'rxjs';

import { MysqlService } from './../../../services/mysql.service';
import { Brand } from '../../../shared/models/brand.model';
import {SubjectTemplateDocs} from '../../../shared/models/subjectTemplateDocsModel.model';

import { FormsModule, Validators } from '@angular/forms';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

import { ToolbarService, LinkService, ImageService, HtmlEditorService } from '@syncfusion/ej2-angular-richtexteditor';
import { GlobalFunctionsService } from './../../../services/global-functions.service';

@Component({
  selector: 'app-subject-com-type-template-doc-view',
  templateUrl: './subject-com-type-template-doc-view.component.html',
  styleUrls: ['./subject-com-type-template-doc-view.component.css'],
  providers: [ToolbarService, LinkService, ImageService, HtmlEditorService]
})
export class SubjectComTypeTemplateDocViewComponent implements OnInit {
  nav: any;
  doc_id: number;
  baseUploadURL: string;
  baseUploadURLEmailTemplates: string;
  model: SubjectTemplateDocs;
  subject_template_doc: any;
  brand_type: any;
  brand_type_name: any;
  subject_com_type_name: any;
  subject_com_type: any;
  job_type_courts: any;
  courts_name: any;
  court_name: any;
  job_type_location: any;
  location_name: any;
  job_type_document: any;
  document_type_name: any;
  job_type_affidavit: any;
  affidavit_type_name: any;
  job_type: any;
  job_type_name: any;
  baseUploadURLOriginalWordTemplates: string;
  file_check_response: any;
  docx_file_check: any;

  constructor(
    private _mysqlService: MysqlService,
    private route: ActivatedRoute,
      private router: Router,
      private http: HttpClient,
      private _demoService: DemoService,
      vcr: ViewContainerRef,
      private modalService: BsModalService,
      private _location: Location,
      public gfunc: GlobalFunctionsService
  ) {
    this.nav = document.querySelector('nav.navbar');
    // this.toastr.setRootViewContainerRef(vcr);
    this.doc_id = +this.route.snapshot.paramMap.get('doc_id');
   }

  ngOnInit() {

        // this.baseUploadURL = this.gfunc.baseUploadURL_BrandAssets + '/'  + this.doc_id; // no trailing slash
        this.baseUploadURL = this.gfunc.baseUploadURL; // all templates reside in the same directory.
        this.baseUploadURLOriginalWordTemplates = this.gfunc.baseUploadURLOriginalWordTemplates;
        this.baseUploadURLEmailTemplates = this.gfunc.baseUploadURLEmailTemplates; // all templates reside in the same directory.
        this.model = new SubjectTemplateDocs();
        this.getSubjectTemplateDoc(this.doc_id);



  }


  getSubjectTemplateDoc(doc_id) {
    this._demoService.getSubjectTemplateDoc(doc_id).subscribe(
      data => { this.subject_template_doc = data;
        const res = data[0];
     
        this.getBrandBrandType(res.brand_type_id);
     
        // stop loading the resourses if not needed.
        if (res.job_type_id >= 1) {
        this.getSubjectComType(res.subject_com_type_id);
        this.getJobTypeLocation(res.job_type_location_id);
        this.getJobTypeDocument(res.job_type_document_type_id);
        this.getJobTypeCourt(res.job_type_location_id);
        this.getJobTypeAffidavit(res.job_type_affidavit_type_id);
        this.getJobType(res.job_type_id);
      }
     
     
        
        // load the drop downs
        // this.getJobTypeLocations(res.job_type_id);
       // this.getJobTypeCourts(res.job_type_court_id);
        // this.getJobTypeDocumentTypes(res.job_type_court_id);
       // this.getJobTypeAffidavitTypes(res.job_type_document_type_id);
        // this.getJobTypes();

// check if docx file exists
this.templateDocxFileExistCheck(res.doc_template_file);

      },
      err => console.error(err),
      () => console.log('')
    );
  }


  getBrandBrandType(brand_type_id){
    this._demoService.getBrandBrandType(brand_type_id).subscribe(
      data => { this.brand_type = data;
        const res = data[0];
        this.brand_type_name = res.brand_type_name;
      },
      err => console.error(err),
      () => console.log('')
    );
  }

  getSubjectComType(subject_com_type_id){
    this._demoService.getSubjectComType(subject_com_type_id).subscribe(
      data => { this.subject_com_type = data;
        const res = data[0];
        this.subject_com_type_name = res.subject_com_type_name;
      },
      err => console.error(err),
      () => console.log('')
    );
  }


  getJobTypeCourt(job_type_location_id){
    this._demoService.getJobTypeCourts(job_type_location_id).subscribe(
       data => { this.job_type_courts = data;
        const res = data[0];
        this.court_name = res.job_type_court_name;
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }

   getJobTypeLocation(job_type_location_id){
    this._demoService.getJobTypeLocation(job_type_location_id).subscribe(
      data => { this.job_type_location = data;
       const res = data[0];
       this.location_name = res.job_type_location_name;
     },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
   }

   getJobTypeDocument(job_type_document_type_id){
    this._demoService.getJobTypeDocument(job_type_document_type_id).subscribe(
      data => { this.job_type_document = data;
       const res = data[0];
       this.document_type_name = res.job_type_document_type_name;
     },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
   }

   getJobTypeAffidavit(job_type_affidavit_type_id){
    this._demoService.getJobTypeAffidavit(job_type_affidavit_type_id).subscribe(
      data => { this.job_type_affidavit = data;
       const res = data[0];
       this.affidavit_type_name = res.job_type_affidavit_type_name;
     },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
   }

   getJobType(job_type_id){
    this._demoService.getJobType(job_type_id).subscribe(
      data => { this.job_type = data;
       const res = data[0];
       this.job_type_name = res.job_type_name;
     },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
   }

   templateDocxFileExistCheck(filename){
      this._mysqlService.templateDocxFileExistCheck(filename).subscribe(
        data => { this.docx_file_check = data;
          // let res = data[0];
          // let res2 = JSON.stringify(data) ;
          // console.log('Response_text' + res.json.reponse_text);
          // console.log('Response_2' + res2);
          // this.file_check_response = res2;
        },
        err => console.error(err),
       // () => console.log('')
      );


      // this._mysqlService.templateDocxFileExistCheck(filename)
      // .subscribe(
      //   res => this.docx_file_check = res,
      //   err => console.error(err.status)
      // );


   }


       // to router navigate back
       public goBack() {
        this._location.back();
      }
  
      docView(doc_id) {
        this.router.navigate(['/admin/communication/com_type_template_doc_view/' + doc_id + '']);
      }
  
      docEdit(doc_id) {
        this.router.navigate(['/admin/communication/com_type_template_doc_edit/' + doc_id + '']);
      }

      docEditTemplateFile(doc_id) {
        this.router.navigate(['/admin/communication/template_doc_view/template/' + doc_id + '']);
      }

      docViewTemplateFile(doc_id) {
        this.router.navigate(['/admin/communication/template_doc_view/template-view/' + doc_id + '']);
      }
      

      
}
